import Image_User from "../../images/man.png";
import Image_Background from "../../images/background_image.jpg";
import makeFriendly from "../../modules/friendlyNumber";
import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import {connect} from "react-redux";
import { getSectionTitle } from "../../redux/actions/actions.js";
import Profile_Posts_Any from "./Profile_Posts_Any.js";
import React from "react";

const Profile_AnyUser = (props) => {
    const [followers,setFollowers] = useState("");
    const [following,setFollowing] = useState("");
    const [user,setUser] = useState([]);
    const navigate = useNavigate();
    const { id } = useParams();
    useEffect(() => {
        props.onGetSectionTitle("Profile");
        try {
            getUser(id);
            getNumberFollowers(id);
            getNumberFollowing(id);
        } catch (error) {
            navigate("/start/signin");
        }
    },[]);
    const getUser = (id) => {
        fetch(`/user?q=${id}`)
        .then(res => res.json())
        .then(data => {
            setUser(data[0])
        })
        .catch(error => console.log(error))
    }
    const getNumberFollowers = (id) => {
        fetch(`/follow/number?q=${id}`)
        .then(res => res.json())
        .then(data => {
            setFollowers(data)
        })
        .catch(error => console.log(error))
    }
    const getNumberFollowing = (id) => {
        fetch(`/follow/numberfollowing?q=${id}`)
        .then(res => res.json())
        .then(data => {
            setFollowing(data)
        })
        .catch(error => console.log(error))
    }
    return(
        <div className="main_content_section_main">
            <div className="profile_header">
                <div className="profile_background_div">
                    <img className="profile_user_background" src={Image_Background} alt="User background" />
                </div>
                <img className="profile_user_image" src={Image_User} alt="User" />
            </div>
            <div className={`main_content_section main_content_section_${props.color_background} profile_info`}>
                <div className="profile_user_name">{user.firstName} {user.lastName}</div>
                <div className="profile_user_username">@{user.userName}</div>
                <div className="profile_user_description">{user.description}</div>
                <div className="profile_user_dates">
                    <div className="profile_user_dates_birth profile_user_dates_div">
                        <i className="fa-solid fa-cake-candles profile_user_dates_icons"></i>
                        <div className="profile_user_dates_spans">
                            <span className="profile_user_dates_text">Born </span>
                            <span className="profile_user_dates_date">{user.birthday}</span>
                        </div>
                    </div>
                    <div className="profile_user_dates_registration profile_user_dates_div">
                        <i className="fa-solid fa-calendar-days profile_user_dates_icons"></i>
                        <div className="profile_user_dates_spans">
                            <span className="profile_user_dates_text">Joined </span>
                            <span className="profile_user_dates_date">{user.registration}</span>
                        </div>
                    </div>
                </div>
                <div className="profile_user_follow">
                    <div className="profile_user_follow_following profile_user_follow_div"><span className="profile_user_follow_number">{makeFriendly(following)}</span> <span className="profile_user_follow_text">Following</span></div>
                    <div className="profile_user_follow_followers profile_user_follow_div"><span className="profile_user_follow_number">{makeFriendly(followers)}</span> <span className="profile_user_follow_text">Followers</span></div>
                </div>
            </div>
            <Profile_Posts_Any id={id} />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background,
        user: state.getUser.user
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onGetSectionTitle: (text) => dispatch(getSectionTitle(text))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Profile_AnyUser);
